import { useDispatch, useSelector } from 'react-redux';
import useAxios from '../axios/useAxios';
import CompaniesList from '../components/CompaniesList';
import React, { useEffect, useState } from 'react';
import {
  STORE_UNAVAILABLE_ALERT_TRIGGER,
} from '../constants/storeConstants';
import { useLocation, useNavigate } from 'react-router-dom';
import { CART_EMPTY } from '../constants/cartConstants';
import PageLoader from '../components/loader/PageLoader';
import { HOME } from '../constants/routes';
import { notifyWarning } from '../utils/Notify';
import { useFunnelTracking } from '../posthog/funnelTracking';
import { useCompaniesList } from '../hooks/useCompaniesList';
import { usePerformanceContext } from '../context/PerformanceContext';

const StoreListScreen = () => {
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { store } = useSelector((state) => state.store);
  const entryQr  = location.state?.entryQr || new URLSearchParams(window.location.search).get('qr') ||'';
  const { success } = useSelector((state) => state.store);
  const [reset, setReset] = useState(false);
  const storeLocked = location.state?.storeLocked;
  const prevPage = location.state?.prevPage;
  const { trackPageViewStoreList } = useFunnelTracking();
  const { storeList, loading: companiesLoading } = useCompaniesList(axiosInstance);


  const { markComplete } = usePerformanceContext();

  useEffect(() => {
    if (markComplete && !companiesLoading && storeList?.length > 0) {
      markComplete();
    }
  }, [companiesLoading, storeList, markComplete]);


  useEffect(() => {
    trackPageViewStoreList({

                   });
  }, [trackPageViewStoreList]);


  useEffect(() => {
    dispatch({ type: CART_EMPTY });
    setReset(true);
    const storeAlert = JSON.parse(
      localStorage.getItem(STORE_UNAVAILABLE_ALERT_TRIGGER),
    );
    if (storeLocked && storeAlert && !storeAlert.isTriggered) {
      localStorage.removeItem('store');
      notifyWarning(
        'Magasin indisponible',
        'Le magasin auquel tu souhaites accéder est indisponible pour le moment. Choisis-en un autre.',
        'Fermer',
        () =>
          localStorage.setItem(
            STORE_UNAVAILABLE_ALERT_TRIGGER,
            JSON.stringify({ isTriggered: true }),
          ),
      );
    }
    localStorage.setItem('entryQr', entryQr);
  }, []);

  useEffect(() => {
    if (!success || !reset) {
      return;
    }
    if (success && store.live === false) {
      notifyWarning(
        'Magasin indisponible',
        'Le magasin auquel tu souhaites accéder est indisponible pour le moment. Choisis-en un autre.',
        'Fermer',
        () =>
          localStorage.setItem(
            STORE_UNAVAILABLE_ALERT_TRIGGER,
            JSON.stringify({ isTriggered: true }),
          ),
      );
    } else if (prevPage) {
      navigate(prevPage);
    } else {
      navigate(HOME);
    }
  }, [success]);

  return (
    <>
      {companiesLoading ? (
        <PageLoader />
      ) : (
        <CompaniesList axiosInstance={axiosInstance} storeList={storeList} />
      )}
    </>
  );
};

export default StoreListScreen;
